@if (banner) {
  <div class="aimo-simple-banner">
    <ng-container *ngTemplateOutlet="bannerContent; context: { banner: banner }"></ng-container>
  </div>
} @else {
  @if (componentData$ | async; as banner) {
    <div class="aimo-simple-banner">
      <ng-container *ngTemplateOutlet="bannerContent; context: { banner: banner }"></ng-container>
    </div>
  }
}


<ng-template #bannerMedia let-banner="banner">
  @if (banner.media) {
    <cx-media [loading]="'lazy'" [container]="banner.media"></cx-media>
  }
  @if (banner.buttonName) {
    <div class="banner-content">
      <h2
        [innerHTML]="banner.buttonName"
      [ngClass]="banner.buttonColor === 'PETROL' ? 'bg-petrol text-white' : 'bg-white text-petrol'"></h2>
    </div>
  }
</ng-template>

<ng-template #bannerContent let-banner="banner">
  @if (banner.urlLink && banner.media) {
    @if (banner.urlLink && isExternal(banner)) {
      <a
        (click)="buttonClicked(banner)"
        [href]="getSafeUrl(banner.urlLink)"
        [target]="getTarget(banner)">
        <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
      </a>
    }
    @if (banner.urlLink && !isExternal(banner)) {
      <a
        (click)="buttonClicked(banner)"
        [routerLink]="banner.urlLink"
        [queryParams]="getInternalQueryParams(banner)"
        [fragment]="banner.urlLinkFragment">
        <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
      </a>
    }
  }
  @if (!banner.urlLink) {
    <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
  }
</ng-template>
